<template lang="html">
  <div class="h-100">
    <!-- <head-component/> -->
    <!-- TODO: Move this to a component -->
    <section class="main-accent-section h-100 p-10px-t">
      <div class="container">
        <head-component />
      </div>
      <div class="container">
        <div class="row">
          <div class="col">
            <h1 class="hero-heading">Welcome back to Codoc</h1>
            <div class="sign-in-panel">
              <form @submit="onSignInSubmit" class="email-signin-form">
                <div class="form-group">
                    <label>Email</label>
                    <input
                      class="form-control"
                      placeholder="Email"
                      v-model="signin_email"/>
                </div>
                <div class="form-group">
                    <label>Password</label>
                    <input
                      class="form-control"
                      placeholder="Password"
                      type="password"
                      v-model="signin_password"/>
                </div>
                <div class="error-message"> {{ errorMessage }}</div>
                <center>
                <button
                  type="submit"
                  :disabled="loading"
                  class="btn btn-lg btn-success btn-signin">
                  <span v-if="loading">
                    <i class="fas fa-circle-notch fa-spin"></i>
                  </span>
                  <span v-else>Sign In</span>
                </button>
                <!-- <div class="signin-subtitle">
                  By signing in, you agree to the
                <div><a href="#">Terms and Conditions</a> and <a href="#">Privacy Policy</a>.</div>
              </div> -->
                <div class="signin-subtitle">
                  <!-- <a href="#" @click="openPWModal">Forgot / reset password?</a> -->
                </br><router-link to="/">Sign up for a new account</router-link>
                </div>
                </center>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <password-reset-modal /> -->
  </div>
</template>

<script>
import {firebase, firebaseui, firebaseuiConfig, firestoreDB} from '@/common/firebaseConfig.js'
// import PasswordResetModal from '@/components/PasswordResetModal.vue'
// import {crypto} from 'crypto'
export default {
  components: {
    // 'password-reset-modal': PasswordResetModal
  },
  mounted: function () {
    let crypto = require('crypto');
    var mtoken = crypto.randomBytes(20).toString('hex');
    // Display the send to messenger buttons
    document.getElementsByClassName("fb-send-to-messenger")[0].setAttribute("data-ref", mtoken);
    FB.init({
      appId            : '777863689251453',
      autoLogAppEvents : true,
      xfbml            : true,
      version          : 'v3.2'
    });
    if (window.FB) {
      console.log("found window.FB");
      window.FB.XFBML.parse();
    }
    // If there is a reset=true query param, show the password reset modal
    if(this.$route.query.reset) {
      this.$modal.show('pw-modal');
    }
    // Subscribe to events from messenge rlogin
    FB.Event.subscribe('send_to_messenger', (e) => {
      // callback for events triggered by the plugin
      console.log("send to messenger callback");
      console.log(e);
      if(e.event=="clicked"){
        // If the plugin is clicked, show a loading spinner after a half second
        setTimeout(()=>{ this.loading=true; }, 500);
      }
    });
    console.log("creating new snapshot listener", mtoken);
    firestoreDB.collection("messengerLogins").doc(mtoken)
      .onSnapshot((doc) => {
          // console.log("messengerLogin changed");
          // alert("login changed!");
          // console.log("Current data: ", doc.data());
          let loginData = doc.data();
          if(loginData != undefined && 'status' in loginData) {
            if(loginData['status'] == 'success') {
              firebase.auth().signInWithCustomToken(loginData['token']).then(() => {
                console.log("Sign in success, do the next thing");
                // let nextPage = this.$cookie.get('continueAfterAuth');
                this.$router.push('/home');
              });
            }
          }
          else {

          }
      });

  },
  data: function () {
   return {
     errorMessage: '',
     loading: false,
   }
 },
 methods: {
   toggleLoading: function(e) {
     alert("toggle loading");
   },
   openPWModal: function(e) {
     e.preventDefault();
     this.$modal.show('pw-modal');
   },
   onSignInSubmit: function(e) {
     e.preventDefault();
     this.loading=true;
     firebase.auth().signInWithEmailAndPassword(this.signin_email, this.signin_password)
     .then(
       (user) => { // onResolve
         console.log('success login');
         this.$router.replace('home');
       },
       (error) => { // onReject
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        this.errorMessage = error.message;
        this.loading=false;
      });
   }
 }
}
</script>

<style lang="scss" scoped>
  @import '~styles/variables.scss';
  .email-signin-form {
    margin-top: 1rem;
  }
  .main-accent-section {
    background-color: #11208D;//$main-accent;
  }
  .hero-heading {
    font-family: 'Heebo';
    font-weight: 400;
    margin-top: 8rem;
    margin-bottom: 2rem;
    text-align: center;
    color: #fff;
    font-size: 2rem;
  }
  .error-message {
    margin: 1rem 0rem;
    color: #ff1f1f;
  }
  .sign-in-panel {
    padding: 40px;
    // padding-top: 10px;
    max-width: 450px;
    margin: 10px auto;
    text-align: left;
    background-color: #fff;
    border-radius: 5px;
    a {
      // color: #b6d9ff;
      /* text-decoration: underline; */
      // font-size: 16px;
    }
    .form-group {
      label {
        font-size: 14px;
        color: $text-light;
        margin-bottom: 0px;
      }
    }
    .btn-signin {
      // font-family: $source-sans-pro;
      margin: 0px auto;
      width: 100%;
      cursor: pointer;

    }
    .btn-signin {
      background-color: #467ABD;
      border: none;
      &:hover {
        background-color: lighten(#467ABD, 10%);
      }
      &:active {
        background-color: lighten(#467ABD, 15%);
      }
    }
    .signin-subtitle {
      max-width: 340px;
    }
  }
</style>

<style lang="scss">
@media (max-width: 767.98px) {
}
</style>
